import { render } from "./toolbars.vue?vue&type=template&id=048e64a9"
import script from "./toolbars.vue?vue&type=script&lang=js"
export * from "./toolbars.vue?vue&type=script&lang=js"

import exportComponent from "/Users/yunusemresogut/Desktop/ishesap-partner/bayi_v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__